import React from 'react'
import { Box, Container } from "@mui/material";
import Barcode from 'react-barcode';
import Constants from '../../utility/constants';

export default function PrintBarcode({ sourceData }) {
    return (
        <Box zIndex={100000}>
            <Container maxWidth="xxl" sx={{ mt: 1 }}>
                <Box
                    sx={{
                        width: "100%",
                        position: "relative",
                        "& .MuiTablePagination-selectLabel": {
                            marginTop: "15px",
                        },
                        "& .MuiTablePagination-displayedRows": {
                            marginTop: "15px",
                        },
                        "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .css-cc8tf1": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                    }}
                >
                    {
                        sourceData.map((item) => {
                            return (
                                <Box display={'block'}>
                                    <Barcode value={item.packetid} />
                                </Box>
                            )
                        })
                    }
                </Box>
            </Container>
        </Box>
    )
}
